import { ApiError } from '@/api/api.error';
import { FetchError } from '@/api/fetch.error';
import { Components } from '@/api/generated/api';
import { i18n } from '@/i18n/translations';
import { isTypeOfString } from 'common/utils/string.utils';

/**
 * Gets the translation key for the error message of the corresponding backend error type
 */
export const getErrorTk = (
  error: unknown,
  overrides?: {
    [P in Components.Schemas.ErrorTypes]?: string;
  },
): string => {
  if (error instanceof ApiError) {
    const errorType = error.getErrorType();
    const tk = overrides?.[errorType as Components.Schemas.ErrorTypes] || `errorMessages.${errorType}`;
    if (i18n.global.te(tk)) return tk;
  } else if (error instanceof FetchError) {
    return 'errorMessages.networkError';
  } else if (isTypeOfString(error)) {
    const tk = `errorMessages.${error}`;
    if (i18n.global.te(tk)) return tk;
  }
  return overrides?.['UNKNOWN'] || 'errorMessages.UNKNOWN';
};

export const getErrorType = (error: unknown): Components.Schemas.ErrorTypes | undefined => {
  if (error instanceof ApiError) {
    const errorType = error.getErrorType();
    return errorType;
  }
  return undefined;
};
